import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ProjectStatus } from '../../../types/projects';
import { getStatusIcon, getStatusLabel, getStatusColor } from '../../../Helpers/ProjectUtils';

interface ProjectStatusModalProps {
    show: boolean;
    onHide: () => void;
    currentStatus: ProjectStatus;
    onStatusChange: (status: ProjectStatus) => void;
    submitting?: boolean;
}

export const ProjectStatusModal: React.FC<ProjectStatusModalProps> = ({
    show,
    onHide,
    currentStatus,
    onStatusChange,
    submitting = false,
}) => {
    const [selectedStatus, setSelectedStatus] = useState<ProjectStatus>(currentStatus);

    useEffect(() => {
        if (show) {
            setSelectedStatus(currentStatus);
        }
    }, [show, currentStatus]);

    const handleConfirm = () => {
        if (selectedStatus !== currentStatus) {
            onStatusChange(selectedStatus);
        }
        onHide();
    };

    const statuses = [ProjectStatus.PLANNED, ProjectStatus.IN_PROGRESS, ProjectStatus.COMPLETED];

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Ändra status</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {statuses.map((status) => (
                        <div
                            key={status}
                            onClick={() => !submitting && setSelectedStatus(status)}
                            style={{
                                padding: '12px 16px',
                                marginBottom: '8px',
                                borderRadius: '8px',
                                border: selectedStatus === status ? `2px solid ${getStatusColor(status)}` : '1px solid #dee2e6',
                                backgroundColor: selectedStatus === status ? `${getStatusColor(status)}10` : '#fff',
                                cursor: submitting ? 'not-allowed' : 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                transition: 'all 0.2s ease'
                            }}
                        >
                            <Form.Check
                                type="radio"
                                name="status"
                                checked={selectedStatus === status}
                                onChange={() => setSelectedStatus(status)}
                                disabled={submitting}
                                style={{ margin: 0 }}
                            />
                            <div
                                style={{
                                    backgroundColor: getStatusColor(status),
                                    color: '#ffffff',
                                    padding: '4px 12px',
                                    borderRadius: '9999px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '4px',
                                    width: '120px'
                                }}
                            >
                                {getStatusIcon(status)}
                                {getStatusLabel(status)}
                            </div>
                        </div>
                    ))}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={submitting}>
                    Avbryt
                </Button>
                <Button variant="primary" onClick={handleConfirm} disabled={submitting}>
                    Bekräfta
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
